<template>
  <div class="today-workstatus" :class="orgList.length > 1 ? 'mgr' : ''">
    <!-- 화면 타이틀 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5">
        <icon-monitor :width="24" :height="24" /> {{ $t('오늘 근태현황') }}
      </v-col>
    </v-row>

    <!-- 오늘 일자 -->
    <v-row class="ma-0">
      <v-col cols="12" class="date">{{ GET_TODAY_DATE }}</v-col>
    </v-row>

    <!-- 부서원 근무근태현황 -->
    <v-row class="ma-0">
      <v-col cols="12" class="pa-0">
        <!-- a. 팀장:조직장겸직시 / 임원: 하위부서가 있을 경우 -->
        <v-expansion-panels
          v-if="orgList.length > 1"
          class="accordion"
          accordion
        >
          <v-expansion-panel v-for="(orgCd, index) in orgList" :key="index">
            <!-- 부서명 -->
            <v-expansion-panel-header>
              {{ orgInfo[orgCd] }}
            </v-expansion-panel-header>
            <!-- 부서원 리스트 -->
            <v-expansion-panel-content>
              <org-gnt-work-sta-list
                v-bind:searchList="listOfEmpByOrg[orgCd]"
                v-bind:authGubun="authGubun"
              ></org-gnt-work-sta-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- b. 그 외 = 조회권한 부서가 1개 일때  -->
        <org-gnt-work-sta-list
          v-else
          v-bind:searchList="listOfEmpByOrg[orgList[0]]"
          v-bind:authGubun="authGubun"
        ></org-gnt-work-sta-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* 부서원근태현황 */
import IconMonitor from '@/assets/customIcon/IconMonitor.vue';
import OrgGntWorkStaList from '@/components/status/OrgGntWorkStaList.vue';
import { getOrgWorkStaByAuthList } from '@/api/workStatus';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');

export default {
  data: () => ({
    orgList: [],
    orgInfo: {},
    listOfEmpByOrg: [],
  }),
  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
    GET_TODAY_DATE() {
      return dayjs().format('YYYY.MM.DD (dd)');
    },
    authGubun() {
      return this.GET_USER_DATA.authGroup.toString() === '20'
        ? 'Executive' // 임원
        : this.GET_USER_DATA.orgChiefYn === 'Y'
        ? 'Chief' // 조직장
        : 'Employee'; // 임직원
    },
  },
  methods: {
    /* 부서원근태현황조회 */
    async fetchOrgWorkStaByAuthList() {
      const paramObj = {
        searchDate: dayjs().format('YYYYMMDD'),
        orgChiefYn: this.GET_USER_DATA.orgChiefYn,
        authGroup: this.GET_USER_DATA.authGroup.toString(),
        pathName: this.$route.name,
      };

      try {
        const response = await getOrgWorkStaByAuthList(paramObj);
        const dataObj = response.data.data;

        // 조회결과가 있을 때 세팅
        if (Object.keys(dataObj).length > 0) {
          this.orgInfo = dataObj.orgInfo;
          this.orgList = Object.keys(dataObj.orgInfo);
          this.listOfEmpByOrg = dataObj.listOfEmpByOrg;
        }
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');

    this.fetchOrgWorkStaByAuthList();
  },
  components: {
    IconMonitor,
    OrgGntWorkStaList,
  },
};
</script>

<style>
/* todayWorkStatus.scss 참고 */
</style>
